import earmarkApi from "@/api/earmark/earmarkApi";

export default {
  namespaced: true,
  state: {},
  mutations: {},
  actions: {
    async addOrUpdate({dispatch}, form) {
      try {
        const response = await earmarkApi.addOrUpdate(form);
        dispatch('NOTIFY_MSG', 'earmark.notification.save',
          {root: true});
        return Promise.resolve(response.data);
      } catch (error) {
        await dispatch('NOTIFY_ERROR', error, {root: true});
        return Promise.reject(error);
      }
    },
    async addOrderSet({dispatch}) {
      try {
        const response = await earmarkApi.addToOrderSet();
        dispatch('NOTIFY_MSG', 'earmark.notification.orderSet',
          {root: true});
        return Promise.resolve(response.data);
      } catch (error) {
        await dispatch('NOTIFY_ERROR', error, {root: true});
        return Promise.reject(error);
      }
    },
    async fetchOrderSetById(_, {id}) {
      try {
        const response = await earmarkApi.fetchOrderSetById(id);
        return Promise.resolve(response.data);
      } catch (error) {
        return Promise.reject(error);
      }
    },
    async fetchOrderSetByReportData(_, {id}) {
      try {
        const response = await earmarkApi.fetchOrderSetByReportData(id);
        return Promise.resolve(response.data);
      } catch (error) {
        return Promise.reject(error);
      }
    },
    async delete({dispatch}, {id}) {
      try {
        await earmarkApi.delete(id);
        dispatch('NOTIFY_MSG', 'earmark.notification.save',
          {root: true});
        return Promise.resolve();
      } catch (error) {
        await dispatch('NOTIFY_ERROR', error, {root: true});
        return Promise.reject(error);
      }
    },
    async fetch() {
      try {
        const response = await earmarkApi.fetch();
        return Promise.resolve(response.data);
      } catch (error) {
        return Promise.reject(error);
      }
    },
    async order({dispatch}, form) {
      try {
        const response = await earmarkApi.order(form);
        dispatch('NOTIFY_MSG', 'earmark.notification.order',
          {root: true});
        return Promise.resolve(response.data);
      } catch (error) {
        await dispatch('NOTIFY_ERROR', error, {root: true});
        return Promise.reject(error);
      }
    },
  }
}
